import React from 'react';

const LCVTopBar = ({metadata, phase}) => {
  const phaseLabel = {
    frontloading: 'Introduction',
    learning: 'Learning',
    workbook_ready: 'Workbook',
    workbook_exercise: 'Workbook',
    workbook_options: 'Workbook',
    knowledge_check: 'Knowledge Check',
    knowledge_check_summary: 'Knowledge Check',
    mastery: 'Mastery Test',
    results: 'Results',
  }[phase] || '';

  return (
    <div className="lcv-top-bar">
      <div className="lcv-course-badge">
        <span className="lcv-course-label">[unit] &bull; {metadata?.subject || '[subject]'}</span>
        <span className="lcv-course-title">{metadata?.topic || '[topic]'}</span>
        <span className="lcv-course-lesson">[lessonNumber] of [totalLessons] &bull; {metadata?.lexileBand || ''} ({metadata?.lexileLevel || ''})</span>
      </div>
      {phaseLabel && <span style={{color: 'rgba(255,255,255,0.4)', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1}}>{phaseLabel}</span>}
      <button className="lcv-btn-exit">Exit</button>
    </div>
  );
};

export default LCVTopBar;
